import { createClient } from 'contentful';
import consts from '../util/consts';

const check = () => process.env.CONTENTFUL_DELIVERY_TOKEN &&
  process.env.CONTENTFUL_SPACE_ID && process.env.CONTENTFUL_ENV;

const client = check() && createClient({
  space: process.env.CONTENTFUL_SPACE_ID || '',
  accessToken: (process.env.CONTENTFUL_HOST === 'preview.contentful.com' ?
    process.env.CONTENTFUL_PREVIEW_TOKEN : process.env.CONTENTFUL_DELIVERY_TOKEN) || '',
  environment: process.env.CONTENTFUL_ENV,
  host: process.env.CONTENTFUL_HOST || 'cdn.contentful.com',
}) || null;

export async function getEntries(content_type: string, locale?: string | null) {
  return client?.getEntries({ content_type, include: 10, locale: locale || consts.DEFAULT_LOCALE })
    .then((entries) => {
      return {
        ...entries.items[0].fields as Object,
        sys: entries.items[0].sys,
      };
    })
    .catch(err => {
      const parsed = JSON.parse(err.message);
      return {
        status: parsed.status,
        message: parsed.message,
        meta: null,
        navigation: null,
        footer: null,
        help: null,
      };
    });
}

export async function getEntry(id: string, locale?: string | null) {
  return client?.getEntry(id, { locale: locale || consts.DEFAULT_LOCALE })
    .then(entries => {
      return entries.fields;
    })
    .catch(err => {
      const parsed = JSON.parse(err.message);
      return {
        status: parsed.status,
        message: parsed.message,
        fields: null,
      };
    });
}


export async function getAvailableCountries(locale?: string | null) {
  if (!process.env.CONTENT_AVAILABLE_COUNTRIES_ID) {
    return {
      status: 400,
      message: 'Available Countries content ID is missing',
      countries: null,
      key: 'Available Countries',
      fallbackLocale: consts.DEFAULT_LOCALE,
    };
  }

  return client?.getEntry(process.env.CONTENT_AVAILABLE_COUNTRIES_ID,
    { locale: locale || consts.DEFAULT_LOCALE })
    .then(entries => {
      return entries.fields;
    })
    .catch(() => {
      return client?.getEntry(process.env.CONTENT_AVAILABLE_COUNTRIES_ID || '',
        { locale: consts.DEFAULT_LOCALE })
        .then(entries => {
          return entries.fields;
        })
        .catch(err => {
          const parsed = JSON.parse(err.message);
          return {
            status: parsed.status,
            message: parsed.message,
            countries: null,
            key: 'Available Countries',
            fallbackLocale: consts.DEFAULT_LOCALE,
          };
        });
      },
    );
}

export default client;
